export default __webpack_public_path__ + "static/media/arrow.ae184884.svg";